/**
 * Readable labels for entity names shown in the UI. Prefer the entity's own
 * displayName (the catalog fields API returns it); these helpers are the fallback
 * so a raw identifier like "PalletPickConfirm" or "pickedinventory" is never shown.
 */

/** "PickedInventory" -> "Picked Inventory", "wms.ReceiveInventory" -> "Receive Inventory", "LPN" -> "LPN". */
export const humanizeEntityName = (name) => {
  if (!name) return '';
  const last = String(name).split('.').pop();
  return last
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
};

/** English plural of a label: "Picked Inventory" -> "Picked Inventory records", "Box" -> "Boxes", "Item" -> "Items". */
export const pluralizeLabel = (label) => {
  if (!label) return '';
  // "inventory" has no everyday plural (FH-181)
  if (/inventory$/i.test(label)) return label + ' records';
  if (/[^aeiou]y$/i.test(label)) return label.slice(0, -1) + 'ies';
  if (/(s|x|z|ch|sh)$/i.test(label)) return label + 'es';
  return label + 's';
};
